import { InjectionToken } from '@angular/core';

export interface CalendarHeaderConfig {
  disableYearButtons: boolean;
}

export const CALENDAR_HEADER_CONFIG = new InjectionToken<CalendarHeaderConfig>(
  'CalendarHeaderConfig',
  {
    providedIn: 'root',
    factory: () => ({
      disableYearButtons: false, 
    }),
  }
);